import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { VesselStatusDisplayName } from 'server/enums/VesselStatus';
import { VesselServiceListing, VesselModel } from './model';

function PageTitle(m : VesselServiceListing) {
    return (m.Model().Status() === null ? '' : VesselStatusDisplayName[m.Model().Status()!] + ' ') + 'Vessels';
}

export const VesselServiceListingView = SuperCritical(({ model: m } : { model : VesselServiceListing }) =>
    <div className="vesselservicelisting pc-page-fixedwidth">
        {/*<loadingindicator params="request: Request" />*/}
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="" onClick={noDefault(m.GoBack)}>&lt;&lt; Back</a>
        </div>
        <h1 className="pc-page-title">
            <div className="vessel-search-breadcrumb">
                <span className="pc-text-label-color">More</span><span className="pc-icon-bullet"></span>
                <span>{PageTitle(m)}</span>
            </div>
            <div className="vessel-search-text">
                <input value={m.SearchText()} placeholder="Search for a vessel by name, callsign, IMO, or MMSI" onChange={e => m.SearchText(e.currentTarget.value)} />
            </div>
        </h1>
        <PageBody model={m} />
    </div>
);

let PageBody = SuperCritical(({ model: m } : { model : VesselServiceListing }) =>
    <div className="page-body pc-card">
        <table className="table">
            <thead>
                <tr>
                    <th>Vessel Name</th>
                    <th>IMO</th>
                    <th>MMSI</th>
                    <th>Call Sign</th>
                    <th>Vessel Type</th>
                    <th>Gross Tonnage</th>
                    <th>Length</th>
                    <th>Beam</th>
                    <th>Max Draft</th>
                </tr>
            </thead>
            <TableBody model={m} />
        </table>
    </div>
);

let TableBody = SuperCritical(({ model: m } : { model : VesselServiceListing }) =>
    <tbody>
        {m.Vessels().map(vessel =>
            <VesselRow vessel={vessel} key={vessel.Model.Id()} />
        )}
    </tbody>
);

let VesselRow = SuperCritical(({ vessel: v } : { vessel : VesselModel }) =>
    <tr className="vessel-row" onClick={v.OnRowClick}>
        <td>{v.Model.Name()}</td>
        <td>{v.Model.IMO()}</td>
        <td>{v.Model.MMSID()}</td>
        <td>{v.Model.CallSign()}</td>
        <td>{v.Model.VesselType()}</td>
        <td>{v.Model.GrossTonnage.toString()}</td>
        <td>{v.Model.Length.toString()}</td>
        <td>{v.Model.Beam.toString()}</td>
        <td>{v.Model.MaxDraft.toString()}</td>
    </tr>
);


// WEBPACK FOOTER //
// ./apps/portcall/vesselservicelisting/view.tsx